import { render } from "./Suche.vue?vue&type=template&id=61d19f82"
import script from "./Suche.vue?vue&type=script&lang=ts"
export * from "./Suche.vue?vue&type=script&lang=ts"

import "./Suche.vue?vue&type=style&index=0&id=61d19f82&lang=scss"
script.render = render

export default script